<template>
    <div class="about font-primary">
      <p
        title="presione para borrar"
        v-if="filtroBusqueda"
        class="text-gray-500 text-left px-10 absolute hover:cursor-pointer"
        @click="cargarProductos(1)"
      >
        Busqueda actual > {{ filtroBusqueda }}
      </p>
      <div class="flex w-full justify-around py-8 flex-wrap gap-y-2">
        <div class="flex">
          <input
            type="text"
            @disabled="cargando"
            @change="cambioBuscador(1)"
            v-model="buscador"
            class="form-control w-40 md:w-72"
            placeholder="Buscar..."
            aria-label="Buscar"
            aria-describedby="basic-addon1"
          />
          <div
            @disabled="cargando"
            @click="cambioBuscador(1)"
            class="bg-red-500 rounded-r"
          >
            <img
              class="w-10"
              src="../assets/icons/search.png"
              alt="icono de busqueda"
            />
          </div>
        </div>
      </div>
    
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div v-for="(item, key) in items" :key="key" class="border-3 rounded h-full py-2 md:px-76 px-10 mx-2 my-1 flex justify-between items-center">
          <div>
              <!-- <img src="" class="text-center w-32"> -->
              <img
              class="w-[300px] h-[300px] min-w-[200px] object-contain"
              v-if="item.imagen1"
              :src="item.imagen1"
              alt="Imagen del articulo"
              />
              <img
              class="w-[300px] h-[300px] min-w-[200px] object-contain"
              v-else
              src="../assets/no-photo.jpg"
              alt="Imagen del articulo"
              />
          </div>
          <div class="py-2">
              <p class="text-center text-[10px]">Art. {{ item.CODIGO_ART }}</p>
              <p class="text-center text-xs min-h-[48px]">{{ item.DESCRIP_ART }}</p>
          </div>
      </div>
    </div>
    <div ref="catalogScrollSentinel" class="h-px w-full"></div>
    <p v-if="cargando && items.length > 0" class="w-full text-center py-4 text-gray-500">Cargando más artículos...</p>

    </div>
  </template>
  
  <script>
  import { defineComponent } from "vue";
  import pedidosService from "../services/pedidos.service";
  import { catalogInfiniteScroll } from "../mixins/catalogInfiniteScroll";
  
  export default defineComponent({
    mixins: [catalogInfiniteScroll],
    data() {
      return {
        buscador: "",
        orden: "pd",
        precioDesde: "",
        precioHasta: "",
        errorItem: "",
        modalClickItemData: {},
        categorias: [],
        clientes: [],
        idcli: '',
        expandedMarcas: {}, // Track expanded marcas
        expandedCategorias: {}, // Track expanded categorias
        items: [],
        cargando: false,
        filtroBusqueda: "",
        tipoFiltro: "",
        ultimoIndex: 1,
        listaItemsCarrito: [],
        thumbnailIndex: 0,
        filtroClientes: '',
        filtrosMarca: '',
        banner: ''
      };
    },
    mounted() {
    //   configService.checkHabilitado("CATALOGO")
    //     .then((res) => {
    //       if (res.data == 1) {
            // this.getConfig()
            // this.cargarCategorias();
            this.cargarProductos(1);
        //     if (this.esVendedor) {
        //       this.cargarClientes();
        //     }
             window.addEventListener("scroll", this.handleScroll);
        //   } else {
        //     this.$router.push("/mantenimiento")
        //   }
        // })
        // .catch(err => {
        //   console.log(err)
        //   this.$router.push("/mantenimiento")
        // })
    },
    beforeUnmount() {
      window.removeEventListener("scroll", this.handleScroll);
    },
    methods: {
      selectThumbnail(index) {
        this.thumbnailIndex = index;
      },
      isImage(url) {
        return url && url.endsWith("image");
      },
      fetchCatalogPage(index) {
        if (this.hayFiltros) {
          this.buscadorGenerico(index)
        } else {
          this.cargarProductos(index)
        }
      },
      buscarImagenProducto(itemIndex, imageIndex) {
        var item = this.items[itemIndex];
        pedidosService
          .getImagenProducto(item.IDART_IO, imageIndex ? imageIndex : "")
          .then((res) => {
            if (res.data.byteLength === 0 && !imageIndex) {
              this.items[itemIndex].imagen1 = "";
              return;
            }
            const contentType = res.headers["content-type"];
  
            if (
              contentType &&
              (contentType.startsWith("image/") ||
                contentType.startsWith("video/"))
            ) {
              const mediaBlob = new Blob([res.data], { type: contentType });
              const mediaObjectURL = URL.createObjectURL(mediaBlob);
              const blobUrlWithExtension = `${mediaObjectURL}.${imageIndex}.${
                contentType.startsWith("image/") ? "image" : "video"
              }`;
  
              if (imageIndex != null) {
                if (!item.carousel) {
                  item.carousel = [];
                }
  
                this.items[itemIndex].carousel.push(blobUrlWithExtension);
                this.items[itemIndex].carousel = this.items[
                  itemIndex
                ].carousel.sort((a, b) => {
                  return a.split(".")[1] - b.split(".")[1];
                });
                this.modalClickItemData.carousel = this.items[itemIndex].carousel;
              } else {
                this.items[itemIndex].imagen1 = mediaObjectURL;
              }
            } else {
              if (res.data.byteLength === 0 && imageIndex != null) {
                if (!item.carousel) {
                  item.carousel = [];
                }
                this.items[itemIndex].carousel.push("." + imageIndex);
                this.items[itemIndex].carousel = this.items[
                  itemIndex
                ].carousel.sort((a, b) => {
                  return a.split(".")[1] - b.split(".")[1];
                });
                this.modalClickItemData.carousel = this.items[itemIndex].carousel;
              } else {
                console.error(
                  "The response does not contain valid media data. Content-Type:",
                  contentType
                );
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
      },
      resetFiltros() {
        this.precioDesde = "";
        this.precioHasta = "";
        this.orden = "pd";
        this.buscador = "";
        this.filtrosMarca = ""
        this.filtroBusqueda = "";
      },
      buscarImagenxItem(index) {
        if (index != null && !this.items[index].imagen1) {
          this.buscarImagenProducto(index, null);
        }
      },

      // filtros de busqueda--------------------------------
      cambioOrdenPrecio(index) {
        this.buscadorGenerico(index)
      },
      // cambioOrdenPrecio(index) {
      //   if (this.orden == "pMm" || this.orden == "pmM") {
      //     this.cargando = true;
      //     var orden = this.orden;
      //     this.resetFiltros();
      //     this.orden = orden;
      //     orden = this.orden == "pMm" ? 1 : 0;
      //     pedidosService
      //       .getProductosConIndexOrdenPrecio(index, orden)
      //       .then((res) => {
      //         if (this.tipoFiltro != "+++ordenPrecio/" + orden) {
      //           this.items = [];
      //         }
      //         this.items.push(...res.data);
      //         this.cargando = false;
      //         this.tipoFiltro = "+++ordenPrecio/" + orden;
      //         this.compararItemsCarrito(index);
      //         this.items.forEach((x, i) => {
      //           this.buscarImagenxItem(i);
      //         });
      //       })
      //       .catch((err) => {
      //         console.log(err);
      //         this.cargando = false;
      //       });
      //   } else {
      //     this.cargarProductos(1);
      //   }
      // },
      buscarRango(index) {
        this.buscadorGenerico(index)
      },
      // buscarRango(index) {
      //   if (this.precioDesde || this.precioHasta) {
      //     this.cargando = true;
      //     var pdesde = this.precioDesde;
      //     var phasta = this.precioHasta;
      //     this.resetFiltros();
      //     this.precioDesde = pdesde;
      //     this.precioHasta = phasta;
      //     pedidosService
      //       .getProductosConIndexRango(index, this.precioDesde, this.precioHasta)
      //       .then((res) => {
      //         if (this.tipoFiltro != "+++rango") {
      //           this.items = [];
      //         }
      //         this.items.push(...res.data);
      //         this.cargando = false;
      //         this.tipoFiltro = "+++rango";
      //         this.compararItemsCarrito(index);
      //         this.items.forEach((x, i) => {
      //           this.buscarImagenxItem(i);
      //         });
      //       })
      //       .catch((err) => {
      //         console.log(err);
      //         this.cargando = false;
      //       });
      //   } else {
      //     this.cargarProductos(1);
      //   }
      // },
      buscarCategoria(ind, filtro, idm, idc, ids) {
        this.filtrosMarca = (filtro + ';' + idm +';' + (idc?idc:'') + ';' + (ids?ids:''))
        this.buscadorGenerico(1)
      },
      // buscarCategoria(index, filtro, idm, idc, ids) {
      //   this.cargando = true;
      //   this.resetFiltros();
      //   pedidosService
      //     .getProductosConIndexCategoria(
      //       index,
      //       idm,
      //       idc ? idc : -1,
      //       ids ? ids : -1
      //     )
      //     .then((res) => {
      //       if (
      //         this.tipoFiltro !=
      //         "+++categoria/" + idm + "," + idc + "," + ids
      //       ) {
      //         this.items = [];
      //       }
      //       this.filtroBusqueda = filtro;
      //       this.items.push(...res.data);
      //       this.cargando = false;
      //       this.tipoFiltro = "+++categoria/" + idm + "," + idc + "," + ids;
      //       this.compararItemsCarrito(index);
      //       this.items.forEach((x, i) => {
      //         this.buscarImagenxItem(i);
      //       });
      //     })
      //     .catch((err) => {
      //       console.log(err);
      //       this.cargando = false;
      //     });
      // },
      cambioBuscador(index) {
        this.buscadorGenerico(index)
      },
      // cambioBuscador(index) {
      //   if (this.buscador) {
      //     this.cargando = true;
      //     var buscador = this.buscador;
      //     this.resetFiltros();
      //     this.buscador = buscador;
      //     pedidosService
      //       .getProductosConIndexBusqueda(index, this.buscador)
      //       .then((res) => {
      //         if (this.tipoFiltro != "+++buscador") {
      //           this.items = [];
      //         }
      //         this.filtroBusqueda = this.buscador;
      //         this.items.push(...res.data);
      //         this.cargando = false;
      //         this.tipoFiltro = "+++buscador";
      //         this.compararItemsCarrito(index);
      //         this.items.forEach((x, i) => {
      //           this.buscarImagenxItem(i);
      //         });
      //       })
      //       .catch((err) => {
      //         console.log(err);
      //         this.cargando = false;
      //       });
      //   } else {
      //     this.cargarProductos(1);
      //   }
      // },
      cargarProductos(index) {
        if (index === 1) {
          this.resetCatalogPagination()
        }
        this.cargando = true;
        this.resetFiltros();
        pedidosService
          .getProductosConIndex(index)
          .then((res) => {
            if (this.tipoFiltro != "" || index == 1) {
              this.items = [];
            }
            this.filtroBusqueda = "";
            this.items.push(...res.data);
            this.cargando = false;
            this.tipoFiltro = "";
            this.items.forEach((x, i) => {
              this.buscarImagenxItem(i);
            });
            this.onCatalogBatchLoaded(index, res.data.length);
          })
          .catch((err) => {
            console.log(err);
            this.cargando = false;
          });
      },
      buscadorGenerico(index) {
        if (index === 1) {
          this.resetCatalogPagination()
        }
        this.cargando = true
        if (this.hayFiltros) {
          var m = null
          var c = null
          var s = null
          var p = null
          var cat = null
          if (this.filtrosMarca) {
            cat = this.filtrosMarca.split(';')[0] ? this.filtrosMarca.split(';')[0] : null 
            m = this.filtrosMarca.split(';')[1] ? this.filtrosMarca.split(';')[1] : null 
            c = this.filtrosMarca.split(';')[2] ? this.filtrosMarca.split(';')[2] : null 
            s = this.filtrosMarca.split(';')[3] ? this.filtrosMarca.split(';')[3] : null 
          }
          if (this.orden) {
            if (this.orden == 'pMm') {
              p = '1'
            } else if (this.orden == 'pmM') {
              p = '0'
            }
          }
          pedidosService.getProductosFiltrados(index, this.buscador, m, c, s, p, this.precioDesde, this.precioHasta )
            .then(res => {
              if (index == 1) {
                this.items = [];
              }
              this.filtroBusqueda = 
              (this.buscador ? this.buscador + ' - ': '') +
              (cat ? cat + ' - ': '') +
              (this.precioDesde ? this.precioDesde + ' - ': '') +
              (this.precioHasta ? this.precioHasta : '')
              ;
              if (res.data.length > 0) {
                this.items.push(...res.data);
                this.items.forEach((x, i) => {
                  this.buscarImagenxItem(i);
                });
              }
              this.cargando = false
              this.onCatalogBatchLoaded(index, res.data.length);
            })
            .catch((err) => {
              console.log(err)
              this.cargando = false
            })
        } else {
          this.cargarProductos(1)
        }
  
      },
      // fin filtros de busqueda----------------------------
      // toggleMarca(key) {
      //   // Toggle marca's expanded state
      //   this.expandedMarcas[key] = !this.expandedMarcas[key];
      // },
      // toggleCategoria(marcaKey, categoriaKey) {
      //   // Toggle categoria's expanded state
      //   if (!this.expandedCategorias[marcaKey]) {
      //     this.expandedCategorias[marcaKey] = {};
      //   }
      //   this.expandedCategorias[marcaKey][categoriaKey] =
      //     !this.expandedCategorias[marcaKey][categoriaKey];
      // },
      // formatCategorias(cats) {
      //   var marcas = [];
      //   cats.forEach((x) => {
      //     if (!marcas.includes(x.Marca)) {
      //       marcas.push(x.Marca);
      //     }
      //   });
      //   marcas = marcas.map((x) => {
      //     return { marca: x, categorias: [] };
      //   });
      //   marcas.forEach((x) => {
      //     x.categorias = [];
      //     var catsMarca = cats.filter((a) => a.Marca == x.marca);
      //     catsMarca.forEach((c) => {
      //       if (!x.categorias.includes(c.Categoria)) {
      //         x.categorias.push(c.Categoria);
      //       }
      //     });
      //     x.idmarca = catsMarca[0].IDMARCA_IO;
  
      //     x.categorias = x.categorias.map((c) => {
      //       return { categoria: c, subCategorias: [] };
      //     });
  
      //     x.categorias.forEach((c) => {
      //       var id = cats.filter(
      //         (a) => a.Marca == x.marca && a.Categoria == c.categoria
      //       );
      //       c.idcat = id[0].IDCATEGORIA_IO;
      //       var temp = cats.filter(
      //         (a) =>
      //           a.Marca == x.marca && a.Categoria == c.categoria && a.Subcategoria
      //       );
      //       if (temp && temp.length > 0 && temp[0]) {
      //         c.subCategorias = temp.map((s) => {
      //           return {
      //             subcategoria: s.Subcategoria,
      //             idsubcat: s.IDSUBCATEGORIA_IO,
      //           };
      //         });
      //       } else {
      //         x.subCategorias = [];
      //       }
      //     });
      //   });
  
      //   this.categorias = marcas;
      //   this.abrirTodasLasCategorias();
      // },
      // abrirTodasLasCategorias() {
      //   this.categorias.forEach((_, key) => {
      //     this.expandedMarcas[key] = true;
  
      //     this.categorias[key].categorias.forEach((_, categoriaKey) => {
      //       if (!this.expandedCategorias[key]) {
      //         this.expandedCategorias[key] = {};
      //       }
      //       this.expandedCategorias[key][categoriaKey] = true;
      //     });
      //   });
      // },
      // cargarCategorias() {
      //   pedidosService
      //     .getAllCategorias()
      //     .then((res) => {
      //       this.formatCategorias(res.data);
      //     })
      //     .catch((res) => {
      //       console.log(res);
      //     });
      // }
    },
    computed: {
      hayFiltros() {
        return this.buscador || this.filtrosMarca || this.precioDesde || this.precioHasta || this.orden
      },
      clientesFiltrados() {
        if (!this.filtroClientes) {
          return this.clientes
        } else {
          return this.clientes.filter(x => x.descripcion.toLowerCase().includes(this.filtroClientes))
        }
      },
      esVendedor() {
        return this.$root.user.tipo != "cliente";
      },
    },
  });
  </script>
  
  <style>
  .input-number {
    /* Chrome, Safari, Edge, and Opera */
    -webkit-appearance: textfield;
    /* Firefox */
    appearance: textfield;
    /* Remove the up and down arrows */
    -moz-appearance: none;
  }
  
  .clickable {
    cursor: pointer;
  }
  
  .btn-custom-secondary {
    background-color: rgb(217, 217, 217) !important;
  }
  .btn-custom-secondary:hover {
    background-color: rgb(241, 29, 29) !important;
    color: white !important;
  }
  
  .thumbnails {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
  
  .thumbnail {
    width: 50px;
    height: 30px;
    margin: 0 5px;
    cursor: pointer;
  }
  
  .thumbnail.active {
    border: 2px solid blue; /* Style for the active thumbnail */
  }
  </style>
  